import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "../../assets/css/slick.css";
import "../../assets/css/slick-theme.css";
import axios from "axios";
import { HeroSliderConfig } from "../../includes/scripts";
import getSliderData from "./HeroSliderData.json"

const HeroSlider = () => {
  const [homeWeAre, setHomeWeAre] = useState(null);
  const fetchHomeWeare = async () => {
    try {
      const response = await axios.get(
        "https://rss.fastwebforge.com/api/pages/home"
      );
      setHomeWeAre(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchHomeWeare();
  }, []);

//   console.log("Fetched Data:", homeWeAre);
  let heroSection = null;
  if (homeWeAre && homeWeAre.data && homeWeAre.data.sections) {
    heroSection = homeWeAre.data.sections.find(
      (section) => section.title === "hero_section"
    );
  }

//   console.log("Hero Section:", heroSection);


  return (
    <>
      <div className="slider index2">
        <div className="all-slide">
          <Slider {...HeroSliderConfig}>
            {heroSection && heroSection.items
              ? heroSection.items.map((data, i) => (
                  <div key={i}>
                    <div
                      className="single-slide"
                      style={{
                        backgroundImage: data.contents
                          ? `url(${data.contents.background_image})`
                          : "none",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <div className="slider-overlay" />
                      <div className="slider-text">
                        <div className="slider-wraper">
                          {/* {data.contents && data.contents.html ? (
                            <h1 
                              dangerouslySetInnerHTML={{
                                __html: data.contents.html,
                              }}
                            ></h1>
                          ) : (
                            <h1>No Title Available</h1>
                          )} */}
                          {
                            getSliderData.map((data, i) => (
                                <div key={i}>

                                    
                                     
                                          <>
                                          <h1 dangerouslySetInnerHTML={{__html:data.title}}></h1>
                                          </>
                                                
                                              
                                                
                                  </div>         
                                       
                            ))
                        }
                          <h1 dangerouslySetInnerHTML={{__html: getSliderData.title}}></h1>

                          <p>
                            {data.contents && data.contents.short_description
                              ? data.contents.short_description
                              : "No description available"}
                          </p>

                          {/* <li>
                          {data.contents && data.contents.button_text ? (
                            <a href="#" className="btn">
                              {data.contents.button_text}
                            </a>
                          ) : null}
                          </li> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HeroSlider;